export default __webpack_public_path__ + "static/gatsby-icon-b81ff00084dafe61590b1acae79b053e.png";